import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../logo.png';

export function Header() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const location = useLocation();
    const isHome = location.pathname === '/';

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const NavItem = ({ href, to, children, className, onClick }) => {
        if (isHome) {
            return <a href={href} className={className} onClick={onClick}>{children}</a>;
        } else {
            // If it's a hash link on another page, go to home with hash
            // If it is just Home (#hero), go to /
            const target = href === '#hero' ? '/' : `/${href}`;
            return <Link to={target} className={className} onClick={onClick}>{children}</Link>;
        }
    };

    return (
        <header className={`app-header ${isScrolled ? 'scrolled' : ''}`}>
            <div className="header-content">
                <div className="logo-container">
                    <img src={logo} className="app-logo" alt="logo" />
                </div>

                <button className="hamburger-menu" onClick={toggleMenu} aria-label="Toggle menu">
                    <span className={`hamburger-line ${isMenuOpen ? 'open' : ''}`}></span>
                    <span className={`hamburger-line ${isMenuOpen ? 'open' : ''}`}></span>
                    <span className={`hamburger-line ${isMenuOpen ? 'open' : ''}`}></span>
                </button>

                <nav className="nav-links desktop-nav">
                    <NavItem href="#hero" className="nav-link">Home</NavItem>
                    <span className="nav-separator">•</span>
                    <NavItem href="#about" className="nav-link">About</NavItem>
                    <span className="nav-separator">•</span>
                    <NavItem href="#games" className="nav-link">Games</NavItem>
                    <span className="nav-separator">•</span>
                    <Link to="/presskit" className="nav-link">Presskit</Link>
                </nav>

                <nav className={`mobile-nav ${isMenuOpen ? 'open' : ''}`}>
                    <NavItem href="#hero" className="mobile-nav-link" onClick={toggleMenu}>Home</NavItem>
                    <Link to="/presskit" className="mobile-nav-link" onClick={toggleMenu}>Presskit</Link>
                    <NavItem href="#about" className="mobile-nav-link" onClick={toggleMenu}>About</NavItem>
                    <NavItem href="#games" className="mobile-nav-link" onClick={toggleMenu}>Games</NavItem>
                </nav>
            </div>
            <div className="header-divider"></div>
        </header>
    );
}
